import type { WellKnown } from "@/types/well-known";
import { useQuery } from "@tanstack/react-query";

export function useWellKnown() {
  return useQuery<WellKnown>({
    queryKey: ["well-known"],
    queryFn: () => (globalThis as any)._appSettings as Promise<WellKnown>,
    staleTime: Infinity,
  });
}
